// ==== FOOTER: Case Page ==== //

;(function($){
  // Global namespace
  var mwCase     = mwCase || {},
      caseSlider = caseSlider || {},
      caseMap    = caseMap || {},
      caseLMap   = caseLMap || {},
      Lmap       = Lmap || {},
      caseCTA    = caseCTA || {};

  // Global variables
  var $window       = $(window),
      $document     = $(document),
      $body         = $('body');

  if($body.hasClass('page-template-case')) {
    //$.gmap3(false);
  }

  $(function(){

    // Global variables
    var $caseMedia    = $('#case-media'),
        $caseGallery  = $('#case-gallery'),
        $caseMap      = $('#case-map'),
        $gridOverview = $('#grid-overview');

    caseSlider.init = function() {
      var opts = {
        slide: '.slide',
        arrows: true,
        dots: false,
        speed: 600,
        lazyLoad: 'ondemand',
        adaptiveHeight: false,
        accessibility: true,
        infinite: false,
      };

      var mediaButtons = $caseMedia.find('.actions_bar');

      var $caseSlider = $caseGallery.slick(opts);

      $caseSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        var nextSlide = slick.$slides.eq(nextSlide);
        var video = nextSlide.find('video');

        if (video.length) {
          var datalazy = video.data('lazy');
          if (typeof datalazy !== 'undefined') {
            video.attr('src', datalazy);
            video.removeAttr('data-lazy');
          }
        }
      });

      $('.grid_toggle').on('click', function (ev) {
        var video = $('.slide.video').find('video');
        if (typeof video.get(0) !== 'undefined' && !video.get(0).paused) {
          //$('.slide.video').toggleClass('playing');
          video.get(0).pause();
        }

        $caseGallery.toggle();
        $gridOverview.toggleClass('hidden');

        ev.preventDefault();
      });

      $('.fullscreen_toggle').on('click', function (ev) {
        //var start_slide = $caseSlider.data('start-slide');

        //$caseGallery.css('opacity', '0');
        //$caseSlider.slick('slickGoTo', start_slide);
        $caseMap.hide();
        $caseGallery.show();

        var video = $('.slide.video').find('video');
        if (typeof video.get(0) !== 'undefined' && !video.get(0).paused) {
          $('.slide.video').removeClass('playing');
          video.get(0).pause();

          mediaButtons.show();
          $('.slick-arrow').show();
        }

        if ($(this).hasClass('close_fullscreen')) $gridOverview.addClass('hidden');
        if ($(this).hasClass('close_fullscreen')) $('.grid_toggle').hide();
        if (!$(this).hasClass('close_fullscreen')) $('.grid_toggle').show();

        toggleFullscreen();

        $caseSlider.slick('resize');
        //$caseSlider.slick('setPosition');
        $caseSlider.slick('refresh');

        ev.preventDefault();
      });

      $gridOverview.on('click', '.thumb', function (ev) {
        var slick_index = $(this).data('slick-index');

        $caseSlider.slick('slickGoTo', slick_index);
        $gridOverview.addClass('hidden');
        $caseGallery.show();

        ev.preventDefault();
      });

      mediaButtons.on('click', '.gallery_btn', function (ev) {
        var start_slide = $caseSlider.data('start-slide');
        if ($('body').hasClass('fullscreen')) $('.grid_toggle').show();
        if ($('body').hasClass('fullscreen')) $gridOverview.addClass('hidden');
        $caseSlider.slick('resize');
        $caseSlider.slick('slickGoTo', start_slide);
        $caseMap.hide();
        $caseGallery.show();

        ev.preventDefault();
      });

      mediaButtons.on('click', '.video_btn', function (ev) {
        var end_slide = $caseSlider.data('end-slide');
        if ($('body').hasClass('fullscreen')) $('.grid_toggle').show();
        if ($('body').hasClass('fullscreen')) $gridOverview.addClass('hidden');
        $caseSlider.slick('resize');
        $caseSlider.slick('slickGoTo', end_slide);
        $caseMap.hide();
        $caseGallery.show();

        ev.preventDefault();
      });

      mediaButtons.on('click', '.plans_btn', function (ev) {
        if ($('body').hasClass('fullscreen')) $('.grid_toggle').show();
        if ($('body').hasClass('fullscreen')) $gridOverview.addClass('hidden');
        $caseSlider.slick('resize');
        $caseSlider.slick('slickGoTo', 0);
        $caseMap.hide();
        $caseGallery.show();

        ev.preventDefault();
      });

      mediaButtons.on('click', '.map_btn', function (ev) {
        if ($('body').hasClass('fullscreen')) {
          $('.grid_toggle').hide();
          $gridOverview.addClass('hidden');
        }

        //caseMap.init();
        caseLMap.init();

        ev.preventDefault();
      });

      $('.slide.video').on('click', function (ev) {
        var video = $(this).find('video');
        //$(this).toggleClass('playing');

        if (video.get(0).paused) {
          video.get(0).play();
        } else {
          video.get(0).pause();
        }
      });

      $('.slide.video').find('video').on('play', function (e) {
        $(this).parent().addClass('playing');
        mediaButtons.hide();
        $('.slick-arrow').hide();
      });
      $('.slide.video').find('video').on('pause', function (e) {
        $(this).parent().removeClass('playing');
        mediaButtons.show();
        $('.slick-arrow').show();
      });

      // $window.on('orientationchange', function(e)
      screen.orientation.addEventListener('change', function(e) {
        if (!$('body').hasClass('fullscreen')) {
          var video = $('.slide.video').find('video');
          var orientation = screen.orientation.type;

          if ((video.length === 1 && video.get(0).paused) && (orientation == 'landscape-primary' || orientation == 'landscape-secondary')) {
            openFullscreen();
            $caseSlider.slick('resize');
            $caseSlider.slick('refresh');
            //var start_slide = $caseSlider.data('start-slide');
            //$caseSlider.slick('slickGoTo', start_slide);
          } else if (video.length === 0 && (orientation == 'landscape-primary' || orientation == 'landscape-secondary')) {
            openFullscreen();
            $caseSlider.slick('resize');
            $caseSlider.slick('refresh');
          }
        }
      });
    };

    caseLMap.init = function() {
      $caseGallery.hide();
      $caseMap.show();

      if (!$($caseMap.html().trim()).length) {
        var mapID = $caseMap.attr('id');

        var lat = parseFloat($caseMap.data('latitude')),
            lgt = parseFloat($caseMap.data('longitude')),
            adr = $caseMap.data('address');

        var map_opt = {
          zoom: 17,
          minZoom: 10,
          scrollWheelZoom: false,
          center: [lat, lgt],
          closePopupOnClick: false,
          attributionControl: false,
          zoomControl: false
        };

        var iconObj = {};
        var customIcon = L.divIcon({
          html: '<div class="leaflet-pin"></div>',
          iconSize: [34, 34],
          popupAnchor: [-3, -13],
          iconAnchor: [20, 20],
        });
        iconObj = { icon: customIcon };

        if (lat !== '' && lgt !== '') {

          Lmap = L.map(mapID, map_opt);

          L.tileLayer.canvas('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
              //detectRetina: true,
              //doubleSize: true,
              attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="nofollow">OpenStreetMap</a>',
          }).addTo(Lmap);

          L.control.zoom({
            position: 'bottomleft'
          }).addTo(Lmap);

          L.control.attribution({
            prefix: false,
            position: 'topright'
          }).addTo(Lmap);

          L.marker(map_opt.center, iconObj).addTo(Lmap)
          .bindPopup('<a href="https://www.google.com/maps/dir/' + encodeURIComponent(adr) + '"target="_blank" rel="nofollow">' + adr + '</a>', {autoClose: false}).openPopup();

          //Lmap.setView([centerlat, centerlng], zoomLevel);
        }
      }

      Lmap.invalidateSize();
    };

    caseMap.init = function() {
      var lat = $caseMap.data('latitude'),
          lgt = $caseMap.data('longitude'),
          adr = $caseMap.data('address');

      var map_opt = {
        zoom: 17,
        scrollwheel: false,
        fullscreenControl: false,
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_CENTER
        },
        streetViewControlOptions: {
          position: google.maps.ControlPosition.RIGHT_CENTER
        },
        mapTypeControlOptions: {
          position: google.maps.ControlPosition.TOP_CENTER
        },
      };

      var marker = function(map) {
        return {
          position: map.getCenter()
        };
      };

      if (lat !== '' && lgt !== '') {
        var coords = new google.maps.LatLng(lat, lgt);

        marker = function(map) {
          return {
            position: coords
          };
        };

        map_opt.center = coords;
      } else {
        map_opt.address = adr;
      }

      $caseGallery.hide();
      $caseMap.show();

      if (!$($caseMap.html().trim()).length) {
        $caseMap.gmap3(map_opt)
        .marker(marker)
        .infowindow({
          content: adr
        })
        .then(function (infowindow) {
          var thisMap = this.get(0);
          var thisMarker = this.get(1);
          thisMarker.addListener('click', function() {
            infowindow.open(thisMap, thisMarker);
          });
        });
      }
    };

    caseCTA.init = function() {
      // ajax loaded forms
      $document.on('after.load.forminator', function(e, form_id) {
        var form = $('.forminator-custom-form-' + form_id);

        if (form.length) {
          if (typeof mwCasenumber !== 'undefined' && typeof mwShopnumber !== 'undefined') {
            form.find($('input[name="hidden-2"]')).val(mwCasenumber);
            form.find($('input[name="hidden-3"]')).val(mwShopnumber);
          }

          if (typeof openID !== 'undefined' && typeof openTime !== 'undefined') {
            form.find($('input[name="hidden-4"]')).val(openID);
            form.find($('input[name="hidden-5"]')).val(openTime);
          }
        }
      });

      // non ajax forms
      var forms = $('.cta-forms.case-forms form');
      forms.each(function(i, form) {
        if (typeof mwCasenumber !== 'undefined' && typeof mwShopnumber !== 'undefined') {
          $(form).find($('input[name="hidden-2"]')).val(mwCasenumber);
          $(form).find($('input[name="hidden-3"]')).val(mwShopnumber);
        }

        if (typeof openID !== 'undefined' && typeof openTime !== 'undefined') {
          $(form).find($('input[name="hidden-4"]')).val(openID);
          $(form).find($('input[name="hidden-5"]')).val(openTime);
        }
      });

      $('.case-cta:not(.case-cta--external)').on('click', function (ev) {
        ev.preventDefault();
        $window.scrollTop(0);
        var form = $(this).attr('href');

        $('.cta-forms.case-forms, .lightbox').attr('aria-hidden', 'false');
        $(form).toggleClass('active');

        return false;
      });

      $('.cta-toggle.case-forms-toggle').on('click', function (ev) {
        ev.preventDefault();

        $('.cta-forms.case-forms, .lightbox').attr('aria-hidden', 'true');
        $(this).nextAll('form').removeClass('active');

        return false;
      });

      var fbqEventMap = {
        'documents': { event: 'InitiateCheckout', value: 250 },
        'contact-agent': { event: 'InitiateCheckout', value: 250 },
        'book-presentation': { event: 'Purchase', rate: 0.001, fallback: 1000 },
        'open-register': { event: 'Purchase', rate: 0.0005, fallback: 500 }
      };

      function addMetaEventData(form, eventData, specificEventName) {
        if (window.jfMetaCapi && 'function' === typeof window.jfMetaCapi.dataLayerMeta) {
          var meta = window.jfMetaCapi.dataLayerMeta(form, specificEventName);
          for (var key in meta) {
            if (Object.prototype.hasOwnProperty.call(meta, key)) {
              eventData[key] = meta[key];
            }
          }
        }

        return eventData;
      }

      function trackMetaEvent(form, eventName, payload) {
        if (window.jfMetaCapi && 'function' === typeof window.jfMetaCapi.track) {
          window.jfMetaCapi.track(form, eventName, payload);
          return;
        }

        if (typeof window['fbq'] === 'function') {
          fbq('track', eventName, payload);
        }
      }

      function trackFbConversion(form, form_id) {
        var eventConfig = fbqEventMap[form_id];
        var value = 100;
        if (eventConfig) {
          if (eventConfig.rate) {
            var basePrice = Number(window.mwCasePrice);
            if (isFinite(basePrice) && basePrice > 0) {
              value = Math.round(basePrice * eventConfig.rate);
              if (!value) value = eventConfig.fallback;
            } else {
              value = eventConfig.fallback;
            }
          } else if (typeof eventConfig.value === 'number') {
            value = eventConfig.value;
          }
        }
        var payload = {
          content_type: 'home_listing',
          content_ids: mwCasenumber,
          formID: form_id,
          value: value,
          currency: 'DKK'
        };

        if (eventConfig) {
          trackMetaEvent(form, eventConfig.event, payload);
        }

        trackMetaEvent(form, 'Lead', payload);
      }

      function trackGoogleConversion(form, form_id) {
        if (typeof dataLayer === 'undefined') return;

        var property_key = String(mwCasenumber || '').trim().toUpperCase();
        var specificEventName = window.jfMetaCapi ? window.jfMetaCapi.customEventName(form) : '';

        dataLayer.push(addMetaEventData(form, {
          'event': 'formSubmitted',
          'formID': form_id,
          'property_key': property_key
        }, specificEventName));

        var googlePageTypeMap = {
          'documents': 'conversionintent',
          'contact-agent': 'conversionintent',
          'book-presentation': 'conversion',
          'open-register': 'conversion'
        };

        var listing_pagetype = googlePageTypeMap[form_id];
        if (listing_pagetype) {
          dataLayer.push(addMetaEventData(form, {
            'event': 'fireRemarketingTag',
            'google_tag_params': {
              'listing_id': mwCasenumber,
              'listing_pagetype': listing_pagetype,
              'property_key': property_key,
              'form_id': form_id
            },
            'property_key': property_key,
            'formID': form_id
          }, specificEventName));
        }
      }

      $document.on('forminator:form:submit:success', function(formData) {
        var form = formData.target;
        var form_id = $(form).find('input[name="hidden-1"]').val();
        // Google conversions
        trackGoogleConversion(form, form_id);
        // Facebook conversions
        trackFbConversion(form, form_id);
      });
    };

    mwCase.init = function(parent, children) {

      /* ================================
       * Init global
       * ================================ */
      if (typeof dataLayer !== 'undefined') {
        var property_key = String(mwCasenumber || '').trim().toUpperCase();

        dataLayer.push({
          'event': 'fireRemarketingTag',
          'google_tag_params': {
            'listing_id': mwCasenumber,
            'listing_pagetype': 'offerdetail',
            'property_key': property_key
          },
          'property_key': property_key
        });
      }

      $('.case--read-more').on('click', function(ev) {
        ev.preventDefault();
        $(this).prev('.case--description--text').attr('aria-expanded', 'true');
        $(this).toggle();
        return false;
      });

      caseSlider.init();
      caseCTA.init();
    };

    if ($body.hasClass('page-template-case')) mwCase.init();

    function toggleFullscreen() {
      $window.scrollTop(0);
      $('body').toggleClass('fullscreen');

      /*setTimeout(function(){
        $caseGallery.css('opacity', '1');
      }, 600);*/

    }

    function openFullscreen() {
      $window.scrollTop(0);
      $('body').addClass('fullscreen');
    }
  });

}(jQuery));
